<template>
  <div class="login">
    <h1 class="login__title title title--2">{{ $t('login.title') }}</h1>

    <form
      class="login__container"
      method="post"
      @submit.prevent="canSubmit && handleSubmit()"
    >
      <div class="field">
        <input
          v-model="email"
          id="inputEmail"
          class="field__input field__input--text"
          :class="{ 'field__input--filled': email.length }"
          type="email"
          required
        />
        <label for="inputEmail" class="field__label">
          {{ $t('login.label-mail') }}
        </label>
      </div>

      <div class="field">
        <input
          v-model="password"
          id="inputPassword"
          class="field__input field__input--text"
          :class="{ 'field__input--filled': password.length }"
          type="password"
          required
        />
        <label for="inputPassword" class="field__label">
          {{ $t('login.label-password') }}
        </label>
      </div>

      <div class="field__error" v-if="errorMessage">
        <p>{{ errorMessage }}</p>
      </div>

      <div class="login__submit">
        <button type="submit" class="button button--valid" :disabled="!canSubmit">
          {{ $t('login.button-submit') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      email: '',
      password: '',
      errorMessage: null,
    };
  },

  computed: {
    canSubmit() {
      const { email, password } = this;
      return !!(email && password);
    },
  },

  methods: {
    ...mapActions('auth', ['authenticate']),
    async handleSubmit() {
      const { email, password } = this;
      this.errorMessage = null;

      try {
        const user = await this.authenticate({ email, password });

        this.$router.push('/');
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
  },
};
</script>
